import {Flex, Image, Text} from '@chakra-ui/react'
import {defaultAvatarUrl} from '@utils/Const'

const MessageBot = ({data}: {data: any}) => {
  return (
    <Flex w={'90%'} gap={'16px'} alignItems={'center'} mb={'16px'}>
      <Image src={defaultAvatarUrl} w={'40px'} h={'40px'} />
      <Flex alignItems={'center'}>
        <Text fontSize={'16px'} p={'16px'} bg={'#F0F0F0'} borderRadius={'32px'}>
          {data.msg}
        </Text>
      </Flex>
    </Flex>
  )
}
export default MessageBot
